import React, { useCallback, useEffect, useState } from "react";
import LayoutPage from "../Layout";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
// import * as Yup from "yup";
import * as Yup from "yup";
import { toast } from "react-toastify";

function EditContactUs() {
  const { id } = useParams();

  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [renderPage, setRenderPage] = useState(0);
  const [initialValues, setInitialValues] = useState({
    id: "",
    mobileNo: "",
    email: "",
  });
  const navigate = useNavigate();

  const handleCloseBtn = () => {
    navigate("/content");
  };

  const getCategoryDetail = useCallback(async () => {
    try {
      setLoading(true);
      let res = await axios.get(`/content/admin/${id}`);
      // console.log(res);
      // console.log(res.data.data.pageContent.split(":")[1].split("<")[0]);
      const mobile = res.data.data.pageContent
        .split(":")[1]
        .split("<")[0]
        .trim();
      const mail = res.data.data.pageContent.split(":")[2].split("<")[0].trim();
      setCategoryData(res.data.data);
      // setUsersData(res.data.data);

      setInitialValues({
        id: res.data.data._id,
        mobileNo: mobile,
        email: mail,
      });

      setLoading(false);
    } catch (errors) {
      toast(errors.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
    }
  }, [id, renderPage]);

  const validate = (values) => {
    const errors = {};
    if (values.email === "") {
      errors.email = "Please enter the Email";
    }else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
      errors.email = "Invalid email address";
    }
    if(values.mobileNo === ""){
      errors.mobileNo = "Please enter the Mobile Number"
    }
    if (!/^\d*$/.test(values.mobileNo)) {
      errors.mobileNo = "Invalid Mobile Number";
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    enableReinitialize: true,
    onSubmit: async (values) => {
      // console.log("valllllllll", values);
      setDisabledSubmit(true);
      try {
        let formData = new FormData();
        formData.append("mobileNo", values.mobileNo);
        formData.append("email", values.email);
        // console.log("formData => ", formData);
        const obj = {
          mobileNo: values.mobileNo,
          email: values.email,
        };
        // console.log("res ==> ",id);
        let res = await axios.patch(`/content/contact/${id}`, obj);
        setRenderPage(Math.random());
        setDisabledSubmit(false);
        toast(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
        });

        navigate(-1);

        // navigate("/category", { state: { message: res.data.message } });
      } catch (errors) {
        console.log(errors.response.data.message);
        if (errors.response.data.message) {
          toast(errors.response.data.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }
        setDisabledSubmit(false);
      }
    },
  });

  useEffect(() => {
    getCategoryDetail();
  }, [getCategoryDetail]);
  return (
    <>
      <LayoutPage>
        <div className="row">
          {/* <LoadingOverlay active={loading} spinner text="Loading..."> */}
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className="shadow-primary border-radius-lg pt-0 pb-0 "
                >
                  <h6 className="text-white text-capitalize ps-3">
                    {/* Edit Category */}
                    <div className="d-flex justify-content-between align-item-end py-3 px-4">
                      Contact Us{" "}
                      <i
                        className="fa fa-close fonts"
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={handleCloseBtn}
                      ></i>
                    </div>
                  </h6>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <form onSubmit={formik.handleSubmit}>
                    <div className="heading">
                      <h5>Mobile Number</h5>
                    </div>
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        id="mobileNo"
                        name="mobileNo"
                        className="form-control"
                        placeholder="Mobile No"
                        style={{ width: "50px" }}
                        value={formik.values.mobileNo || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.mobileNo ? (
                      <div className="text-danger">
                        {formik.errors.mobileNo}
                      </div>
                    ) : null}

                    <div className="heading">
                      <h5>Email</h5>
                    </div>
                    <div className="input-group input-group-outline mb-3">
                      <input
                        type="text"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        value={formik.values.email || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {formik.errors.email ? (
                      <div className="text-danger">{formik.errors.email}</div>
                    ) : null}

                    <div className="text-center">
                      &nbsp;&nbsp;
                      <button
                        type="submit"
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        {disabledSubmit ? (
                          <div>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="sr-only"></span> Submitting
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          {/* </LoadingOverlay> */}
        </div>
      </LayoutPage>
    </>
  );
}

export default EditContactUs;
